import { Card, Checkbox, Button } from 'src/components/UIComponents'
import AppNavbar from 'src/components/Dashboard/Layout/AppNavbar/AppNavbar.vue'
import AppFooter from 'src/components/Dashboard/Layout/AppFooter/AppFooter.vue'
import messages from './ForgotPassword.json'

export default {
  name: 'ForgotPassword',

  i18n: messages,

  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
  },

  data() {
    return {
      form: {
        email: null,
      },
    }
  },

  beforeDestroy() {
    this.closeMenu()
  },

  methods: {
    submitForm() {
      this.$validator.validateAll().then((isValid) => {
        return isValid ? this.askPassword() : null
      })
    },

    /**
     * Clic sur le bouton
     */
    askPassword() {
      this.$eventHub.$emit(this.$eventHub.LOADING.START)
      const dto = {
        mail: this.form.email,
        domain: document.location.origin,
      }
      this.$axios.post('/rest/public/bd/password/forgot/', dto).then(
        (response) => {
          this.$notify.success({
            title: this.$t('notifications.email.success.title'),
            message: this.$t('notifications.email.success.message'),
          })
          this.gotoLogin()
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        },
        (error) => {
          this.$notify.error({
            title: this.$t('notifications.email.error.title'),
            message: this.$t('notifications.email.error.message'),
          })
          this.$eventHub.$emit(this.$eventHub.LOADING.END)
        }
      )
    },

    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },

    gotoLogin() {
      this.$router.push({
        path: '/login',
      })
    },

    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
  },
}
